import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { SiteReportUnitAnalysis } from '@/libs/fleet-api/services/types';
import { Divider, Form, Input } from 'antd';
import { FC } from 'react';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

const FBDHSiteVisitReportUnit: FC = () => {
	const { siteReport, surveyInformation } = useFBDHVisitReportApprovalPage();
	const { form, fieldName } = useForm<SiteReportUnitAnalysis<'payload'>>();

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					additionalUnitInfo: siteReport?.additionalUnitInfo,
					operatingUnitVerification: siteReport?.operatingUnitVerification,
					unitNeedsVerification: siteReport?.unitNeedsVerification,
				} as SiteReportUnitAnalysis<'payload'>
			}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('unitNeedsVerification')}
				label="Verifikasi Kebutuhan Unit"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('operatingUnitVerification')}
				label="Verifikasi Unit yang sedang Beroperasi"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalUnitInfo')}
				label="Informasi Lainnya"
				labelCol={{
					span: 6,
				}}
			>
				<Input.TextArea
					rows={4}
					disabled
				/>
			</Form.Item>
		</Form>
	);
};

export default FBDHSiteVisitReportUnit;
